module.exports = __webpack_public_path__ + "img/buen_fin2.173b34d5.jpg";